import $ from 'jquery'
import { algoliasearch } from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import { highlight } from 'instantsearch.js/es/helpers'
import { configure, index } from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import { connectSearchBox, connectHits } from 'instantsearch.js/es/connectors'

import {
  algoliaAppId,
  algoliaApiKey,
  productSearchIndex,
  productSearchSuggestionsIndex,
} from '../variables'

import { productHit, noResult } from '../templates'
import headerSearchBox from '../components/headerSearchBox'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n
const object = vnObject

const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
const myNavbar = $('.header-search')

const navbarCustomSearchBox = connectSearchBox(headerSearchBox)

const productItem = ({ hits, sendEvent, widgetParams }) => {
  const container = document.querySelector(widgetParams.container)
  container.innerHTML = `
      ${
      hits.length
          ? hits
              .map((item) => productHit(item, 'header-search__item'))
              .join('')
          + (object.searchCTA || '') // <-- Ici on concatène correctement
          : object.noResultCTA
      }
  `

  container
      .querySelectorAll('.feed-product__wrapper')
      .forEach((element, index) => {
        element.addEventListener('click', (event) => {
          sendEvent('click', hits[index], 'Product Clicked')
        })
      })
}

const navbarProductItems = connectHits(productItem)

// 🧠 INIT de la recherche
const headerSearch = instantsearch({
  indexName: object.currentLanguageCode + productSearchIndex,
  searchClient,
  insights: true,
  future: { preserveSharedStateOnUnmount: true },
})

if (myNavbar.length) {
  headerSearch.addWidgets([
    navbarCustomSearchBox({
      container: '.js-search-handler',
      placeholder: __('Search a product', 'vn'),
      showLoadingIndicator: false,
    }),

    navbarProductItems({
      container: '.header-search-hits',
    }),

    configure({
      hitsPerPage: 4,
    }),
  ])

  headerSearch.start()
}

export { headerSearch }
